import React from 'react';
import './App.css';
import Navbar from './Components/Navbar/Navbar';
import Contact from './Components/contact/Contact';
import Main from './Components/Home/Main';
import Map from './Components/Map/Map';
import About from './Components/About/About';
import Footer from './Components/Footer/Footer';
import Gallery from './Components/Gallery/Gellery';
import Courses from './Components/Coures/Courses';
import Home from './Components/Home/Home';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './Components/ScrollTop';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Reviews from './Components/Gallery/Reviews';
import { Analytics } from "@vercel/analytics/react"
import { Helmet } from 'react-helmet';

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className='App flexs flex-column bg-light'>
      <Helmet>
          <title>Holy Institute - Learn German</title>
          <meta name="description" content="Learn German at Holy Institute. We offer flexible German language courses ranging from A1 to B2 levels." />
        </Helmet>
        <Navbar />
        <div
          style={{
            position: 'fixed',
            bottom: '40px',
            right: '20px',
            zIndex: 2,
          }}
        >
          <a className='cardhover' href="https://wa.me/919495123689?text=Hello%20Hiljo%20Joy,%20I%20am%20interested%20in%20learning%20German%20language%20at%20the%20Holy%20Institute.%20Please%20provide%20more%20details.">
            <WhatsAppIcon
              style={{ color: 'greenyellow' }}
              fontSize='large'
              className='bg-success rounded-circle'
            />
          </a>
        </div>

        <Routes>
          <Route path="/Why learn German?" element={<Home />} />
          <Route path="/" element={ <div className="flexs-all-col">
            <Home/>
            <div className="w-50 border mb-5"></div>
            <Reviews/>
            <div className="w-50 border mb-5"></div>
            <Courses/>
            <div className="w-50 border mb-5"></div>
            <Gallery/>
            <div className="w-50 border mb-5"></div>
            <About/>
            <div className="w-50 border mb-5"></div>
            <Contact/>
            <div className="w-100 border my-5 border-dark"></div>
          </div>} />

          <Route path="/Home" element={ <div className="flexs-all-col">
            <Home/>
            <div className="w-50 border mb-5"></div>
            <Reviews/>
            <div className="w-50 border mb-5"></div>
            <Courses/>
            <div className="w-50 border mb-5"></div>
            <Gallery/>
            <div className="w-50 border mb-5"></div>
            <About/>
            <div className="w-50 border mb-5"></div>
            <Contact/>
            <div className="w-100 border my-5 border-dark"></div>
          </div>} />
          <Route path="/main" element={<><Main /> <Reviews/></>} />
          <Route path="/Our Courses" element={<> <Courses /> <Reviews/></>} />
          <Route path="/Gallery" element={<><Gallery /> <Reviews/></>} />
          <Route path="/about us" element={<> <About /> <Reviews/></>} />
          <Route path="/Get Admission" element={<Contact />} />
          <Route path="/contact us" element={<Contact />} />
          <Route path="/map" element={<Map />} />
        </Routes>
        <Footer />
        <Analytics/>
      </div>
    </Router>
  );
};

export default App;